'use strict';

const jQuery = require('jquery');
const _ = require('lodash');
const GoogleMapsLoader = require('google-maps');

const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');

let tpl = require('./template/input.hbs');
let itemTpl = require('./template/item.hbs');
let locationItemTpl = require('./template/location_item.hbs');

GoogleMapsLoader.LIBRARIES = ['places'];


FormBuilder.register('map', function(config) {
    let self = {};
    let $element;
    let result = {};
    let locations = [];

    GoogleMapsLoader.KEY = config.api_key;

    self = new ElementClass(config);
    if (!Array.isArray(config.value)) {
        locations.push(config.value);
    } else {
        locations = config.value || [];
    }

    const getLocationIndex = function(location) {
        let elementIndex = -1;

        locations.forEach(function(element, index) {
            if (element.label === location) {
                elementIndex = index;
            }
        });

        return elementIndex;
    };

    const onDelete = function($element, result) {
        let index = getLocationIndex(result);

        if (index !== -1) {
            locations.splice(index, 1);
            $element.remove();
        }
    };

    self.render = function() {
        $element = jQuery(tpl());
        let $input = $element.find('input');
        let $ul = $element.find('.list-autocomplete');
        let $resultList = $element.find('.list-results');

        $resultList.html('');
        locations.forEach(function(result) {
            $resultList.append(jQuery(locationItemTpl({'label': result.label})));
        });

        let $removeBtn = $resultList.find('button.remove');

        $removeBtn.on('click', function() {
            let $current = jQuery(this);
            let $btnElement = jQuery($current[0].previousElementSibling);

            onDelete($btnElement.parent(), $btnElement[0].dataset.label);
        });

        GoogleMapsLoader.load(function(google) {
            let autocomplete = new google.maps.places.AutocompleteService();
            let geoCoder = new google.maps.Geocoder();

            $input.on('input', function() {
                $ul.removeClass('d-none');
                $ul.html('');

                if (!_.isEmpty($input.val())) {
                    autocomplete.getPlacePredictions({
                        'input': $input.val(),
                        'types': [],
                    }, function(data) {
                        _.forEach(data, function(item) {
                            let $item = jQuery(itemTpl({'description': item.description}));

                            $item.on('click', function() {
                                $ul.addClass('d-none');
                                result = {};
                                result.label = jQuery(this).find('.label').text();

                                geoCoder.geocode({
                                    'address': result.label,
                                }, function(geoResult, status) {
                                    if (google.maps.GeocoderStatus.OK === status) {
                                        result.lat = geoResult[0].geometry.location.lat();
                                        result.lng = geoResult[0].geometry.location.lng();
                                    }
                                });

                                $ul.html('');

                                if (getLocationIndex(result.label) === -1) {
                                    $resultList.append(jQuery(locationItemTpl({'label': item.description})));
                                    locations.push(result);

                                    let $removeBtn = $resultList.find('button.remove');

                                    $removeBtn.on('click', function() {
                                        let $current = jQuery(this);
                                        let $btnElement = jQuery($current[0].previousElementSibling);

                                        onDelete($btnElement.parent(), $btnElement[0].dataset.label);
                                    });
                                }

                                $input.val('');
                            });

                            $ul.append($item);
                        });
                    });
                }
            });
        });

        return $element;
    };

    self.getData = function() {
        return locations || [];
    };

    return self;
});
